import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaGerenciar.vue?vue&type=template&id=3c4c3a22&scoped=true"
import script from "./ModalSolicitacaoCirurgiaGerenciar.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaGerenciar.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaGerenciar.vue?vue&type=style&index=0&id=3c4c3a22&prod&lang=scss&scoped=true"
import style1 from "./ModalSolicitacaoCirurgiaGerenciar.vue?vue&type=style&index=1&id=3c4c3a22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4c3a22",
  null
  
)

export default component.exports